import {
  Settings,
  Users,
  AlertTriangle,
  CheckCircle,
  MessageSquare,
  X,
  Plus,
  Trash2,
  Clock,
  Mail,
  Smartphone,
  ChevronRight,
  ShieldAlert,
  Bot,
  Send,
  Check,
  XCircle,
  Bold,
  Italic,
  Underline,
  List,
  ListOrdered,
  AlignLeft,
  Link2
} from 'lucide-react';
import { useState } from 'react';
import CandidateTable from './candidateList';
import searchicon from "../../assets/images/search-lg-icon.svg";



const MOCK_CANDIDATES = [
  {
    id: "C-1001",
    name: "Alexia Vance",
    appliedDate: "Oct 24, 2025",
    tokenExpiry: "Oct 31, 2025",
    status: "Screening Complete",
    recommendation: "Recommended",
    fraudFlag: false,
    transcript: [
      { sender: 'AI', text: "Hi Alexia! I'm LYWO's AI assistant. Ready for a quick chat about the Senior Frontend role?" },
      { sender: 'Candidate', text: "Yes, absolutely! Happy to chat." },
      { sender: 'AI', text: "Great. First, are you still interested in this position and comfortable with a hybrid work setup in New York?" },
      { sender: 'Candidate', text: "Yes, I am currently based in Brooklyn so hybrid in NY is perfect." },
      { sender: 'AI', text: "Let's dive into a quick technical question. How do you handle state management in a large-scale React application?" },
      { sender: 'Candidate', text: "I typically use Redux Toolkit for global state, but I lean heavily on React Query for server state caching. It keeps the UI snappy and reduces boilerplate." }
    ]
  },
  {
    id: "C-1002",
    name: "Marcus Thorne",
    appliedDate: "Oct 25, 2025",
    tokenExpiry: "Nov 01, 2025",
    status: "Screening Complete",
    recommendation: "Maybe Not",
    fraudFlag: true,
    fraudReason: "2nd Rejoin Rule Triggered (Test environment compromised)",
    transcript: [
      { sender: 'AI', text: "Hi Marcus! Ready for your screening for the Backend Developer role?" },
      { sender: 'Candidate', text: "Yep, let's go." },
      { sender: 'AI', text: "Can you explain how you would optimize a slow-performing SQL query?" },
      { sender: 'Candidate', text: "Let me check." },
      { sender: 'System', text: "⚠️ [SYSTEM ALERT: Candidate disconnected and rejoined 2 times within 3 minutes]" },
      { sender: 'Candidate', text: "I would use EXPLAIN to look at the query plan and add indexes to the columns being filtered." }
    ]
  },
  {
    id: "C-1003",
    name: "Elena Rodriguez",
    appliedDate: "Oct 26, 2025",
    tokenExpiry: "Nov 02, 2025",
    status: "Pending Response",
    recommendation: "Unsure",
    fraudFlag: false,
    transcript: [
      { sender: 'AI', text: "Hi Elena! Are you available to start the screening process?" },
      { sender: 'Candidate', text: "I am currently traveling, can we do this tomorrow?" },
      { sender: 'AI', text: "Of course! The link will remain active for 7 days. Just click it whenever you're ready." }
    ]
  }
];

function ReviewDashboard(){



    const [selectedIds, setSelectedIds] = useState([]);

      const [emailModalConfig, setEmailModalConfig] = useState({ isOpen: false, type: 'test', candidates: [] });
    
    
    
    
    
      const toggleSelectAll = () => {
        if (selectedIds.length === MOCK_CANDIDATES.length) {
          setSelectedIds([]);
        } else {
          setSelectedIds(MOCK_CANDIDATES.map(c => c.id));
        }
      };
    
    
      const toggleSelect = (id) => {
        setSelectedIds(prev =>
          prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
        );
      };

      const handleActionClick = (type, candidates) => {
    setEmailModalConfig({ isOpen: true, type, candidates });
  };

  const getBadgeClass = (rec) => {
    switch(rec) {
      case 'Recommended': return 'badge-excellent';
      case 'Maybe Not': return 'badge-normal';
      case 'Unsure': return 'badge-unsure';
      default: return 'badge-unsure';
    }
  };


    return<div className= " candListBox mt-2">
    <div className="mb-4">
  <div className="d-flex justify-content-between align-items-center g-2">
    {/* Left: title */}
    <div className="canLisTxtStyl col-12 col-sm-4">
      <div>
      <p className="m-0 fw-bold text-start">Review & Decision Dashboard</p>
      <p className="text-muted small m-0 text-start fw-normal mt-0  " style={{fontSize:'11px'}}>Review AI screening results and take action on candidates.</p>
      </div>
    </div>

    {/* Center: search */}
    <div className="canLisIconBox ms-1 activeInAvtie d-flex align-items-center"
            // style={isFocus ? { border: "1px solid var(--ff-color-focus-ring-blue)" } : {}}
    
        >
    
            <input
                type="text"
                className="border-0 search-input"
                style={{ width: "92%" }}
                // value={search}
                // onFocus={() => setIsFocus(true)}
                // onBlur={() => setIsFocus(false)}
                // onChange={(e) => {
                //     setSearch(e.target.value);
                // }}
            />
            <img src={searchicon} className="boxIcon" alt="Logo" />
        </div>
   

    {/* Right: empty spacer to keep search centered */}
    {/* <div className="col-sm-4 d-none d-sm-block" /> */}
  </div>
</div>
    
    
          <div className="overflow-x-auto w-full">
            {selectedIds.length > 0 && (
              <div className="bg-[var(--color-indigo-100)] border border-[var(--brand-primary)] rounded-lg p-2 mb-3 flex justify-between items-center animate-in fade-in slide-in-from-top-2">
                 <span className="text-sm font-semibold text-[var(--brand-primary)] ml-2">{selectedIds.length} candidate(s) selected</span>
                 <div className="flex gap-2">
                    <button
                      className="btn btn-outline-primary bg-white text-xs py-1 px-3 min-h-0 h-auto"
                      onClick={() => {
                        const selectedCands = MOCK_CANDIDATES.filter(c => selectedIds.includes(c.id));
                        handleActionClick('test', selectedCands);
                      }}
                    >
                       <Send size={14} /> Test Message
                    </button>
                 </div>
              </div>
            )}
    
            <CandidateTable
            MOCK_CANDIDATES={MOCK_CANDIDATES}
            selectedIds={selectedIds}
            toggleSelect={toggleSelect}
            toggleSelectAll={toggleSelectAll}
            />
          </div>
        </div>

}

export default ReviewDashboard